import React, {useEffect, useState} from 'react';
import {Offcanvas, Spinner} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {IImageManualModel} from '../../types/manualFinder';
import ManualDrawerFooter from './ManualDrawerFooter';
import ManualDrawerList from "./ManualDrawerList";
import {getManualsByImages} from "../../services/manualFinder/getManualsByImages";
import {useExtractedImagesState} from "../../hooks";

interface IManualDrawerProps {
    forceFeedback: boolean;
}

export const ManualDrawer: React.FC<IManualDrawerProps> = ({ forceFeedback }) => {
    const {
        displayImageManuals,
        selectedImages,
        setDisplayImageManuals,
        resetSelectedImages,
    } = useExtractedImagesState();
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [imageManuals, setImageManuals] = useState<IImageManualModel[]>([]);
    const [isFeedBackProvided, setIsFeedBackProvided] = useState(false);

    useEffect(() => {
        fetchManuals().catch(e => console.error(e));
        setIsFeedBackProvided(false);
    }, [selectedImages]);

    const fetchManuals = async () => {
        setIsLoading(true);
        const manualResponse = await getManualsByImages(selectedImages);
        if (manualResponse.length > 0) {
            setImageManuals(manualResponse);
        }
        setIsLoading(false);
    };

    const handleCloseModal = () => {
        if (!isFeedBackProvided && forceFeedback) return;
        resetSelectedImages();
        setDisplayImageManuals(false);
    };

    return (
        <Offcanvas show={displayImageManuals} onHide={handleCloseModal} placement="end" backdrop={false}
                   className="manual-drawer">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title className="d-flex justify-content-center">
                    {t("Manual.ManualDetails")}
                </Offcanvas.Title>
            </Offcanvas.Header>

            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    <Offcanvas.Body>
                        <ManualDrawerList imageManuals={imageManuals}/>
                    </Offcanvas.Body>
                    {forceFeedback ? (
                        <ManualDrawerFooter
                            imageManuals={imageManuals}
                            setIsFeedBackProvided={setIsFeedBackProvided}
                            isFeedBackProvided={isFeedBackProvided}
                        />
                    ) : null}
                </>
            )}
        </Offcanvas>
    );
};
